import type { Theme } from 'Types';
import babas from './babas';
import baemingo from './baemingo';
import eggs from './eggs';
import ohpoke from './ohpoke';
import senstreet from './senstreet';
import tacostudios from './tacostudios';
import nyc from './nyc';
import brodernas from './brodernas';
import andysburger from './andysburger';
import saigonBaguette from './saigon-baguette';
import reloadSuperfoodbar from './reloadSuperfoodbar';
import ubSushi from './ub-sushi';
import umami from './umami';
import ilovePizza from './ilove-pizza';
import fiffis from './fiffis';
import zocalo from './zocalo';
import zocaloDK from './zocaloDK';
import nemNemQuan from './nemNemQuan';
import greekGrillHouse from './greekGrillHouse';
import barcontrol from './barcontrol';
import vanadis from './vanadis';
import wrapsody from './wrapsody';
import hakee from './hakee';
import thaitec from './thaitec';
import navaraza from './navaraza';
import ryfylkeGardsysteri from './ryfylkeGardsysteri';
import svithunHotel from './svithunHotel';
import pasterian from './pasterian';
import jettzBurger from './jettzBurger';
import varPizza from './varPizza';
import trappan from './trappan';
import kebabdudes from './kebabdudes';
import sakura from './sakura';
import nollettan from './nollettan';
import baoYing from './baoYing';

const companies: { [key: string]: Theme } = {
  babas,
  baemingo,
  eggs,
  ohpoke,
  senstreet,
  tacostudios,
  nyc,
  brodernas,
  andysburger,
  saigonBaguette,
  reloadSuperfoodbar,
  ubSushi,
  umami,
  ilovePizza,
  fiffis,
  zocalo,
  zocaloDK,
  nemNemQuan,
  greekGrillHouse,
  barcontrol,
  vanadis,
  wrapsody,
  hakee,
  thaitec,
  navaraza,
  ryfylkeGardsysteri,
  svithunHotel,
  pasterian,
  jettzBurger,
  varPizza,
  trappan,
  kebabdudes,
  sakura,
  nollettan,
  baoYing
};

export default companies;
